module.exports = __webpack_public_path__ + "img/LOGO_HANSA_MONOCHROM_haushaltsgerate P199.6d3b8c9a.png";